import { createApiClientContext } from '@wix/package-picker-shared';
const eclipseOfferingApiClientContext = {};
export const EclipseOfferingApiClientContext = createApiClientContext(eclipseOfferingApiClientContext);
//# sourceMappingURL=eclipse-offering.context.js.map